export enum VoucherListControlMode {
  CREATE = "create",
  SELECT = "select"
}
